import "./SelectGroupComp.css";
import { defineComponent as a, provide as c, computed as n, openBlock as s, createElementBlock as u, normalizeClass as m, renderSlot as d } from "vue";
import { s as i } from "./selectGroupCompKey.5138b3ee.js";
import { _ } from "./_plugin-vue_export-helper.dad06003.js";
const f = /* @__PURE__ */ a({
  __name: "SelectGroupComp",
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    horizontal: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const e = t, p = l;
    function r(o) {
      p("update:modelValue", o);
    }
    return c(i, {
      parentValue: n(() => e.modelValue),
      handleSelection: r
    }), (o, v) => (s(), u("div", {
      class: m(["selectGroup", {
        "selectGroup--horizontal": e.horizontal,
        "selectGroup--vertical": !e.horizontal
      }])
    }, [
      d(o.$slots, "default", {}, void 0, !0)
    ], 2));
  }
});
const y = /* @__PURE__ */ _(f, [["__scopeId", "data-v-dc8c8d7f"]]);
export {
  y as SelectGroupComp
};
//# sourceMappingURL=SelectGroupComp.js.map
